module.exports = __webpack_public_path__ + "static/media/51_A.0b1e2857.png";